import { SessionUserSelectors } from '~selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { areAllSelectedUsersServerAdmins, isSingleSelectSiteUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../app/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { siteUserRemove } from '../actions/SiteUserMenuActions';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserRemoveAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserRemove,
  translateName: Messages.remove_action,
  isVisible: (targetItems: ISiteUserInfo[], state: AppState) => {
     // - Disallow if session user is not allowed (per server setting) to manage users.
    // - Disallow if the only selection is a guest user.
    // - Disallow site admins from attempting to remove a set of all server admins
    return targetItems.length > 0
      && SessionUserSelectors.canManageUsers(state)
      && !isSingleSelectSiteUserGuest(targetItems)
      && (!areAllSelectedUsersServerAdmins(targetItems) || SessionUserSelectors.isSessionServerAdmin(state))
      && state.spaceInfo.spaceType === 'siteusers';
  },
  isClickable: (_availableActions: {}, _targetItems: ISiteUserInfo[], _state: AppState) => {
    return true;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserRemove(targetItems)
};
